export default __webpack_public_path__ + "static/media/025.7068311f.jpg";